export const productName = 'THE COMPLETE HYDROLOGY TEACHING COLLECTION';
export const productShortName = 'THE COMPLETE HYDROLOGY TEACHING COLLECTION';
export const productImage = 'https://cdn.magicpatterns.com/uploads/x5Mc46MfLk1yhZL8L9t7pB/MOCKUP.png';

export const checkoutUrl = 'https://hydrology.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Foundations of Hydrology',
  'Volume 2 — The Hydrological Cycle & Water Balance',
  'Volume 3 — Precipitation, Climate & Hydrometeorology',
  'Volume 4 — Surface Water, Rivers & Watersheds',
  'Volume 5 — Groundwater & Aquifer Systems',
  'Volume 6 — Water Quality & Aquatic Environments',
  'Volume 7 — Floods, Droughts & Hydrological Hazards',
  'Volume 8 — Water Resources Management & Sustainability',
  'Volume 9 — Teaching Hydrology: Lesson Planning & Assessment',
  'Bonus 1 — 150 Hydrology Activities',
  'Bonus 2 — Complete Assessment Bank',
  'Bonus 3 — 100 Real-World Case Studies',
  'Bonus 4 — 50 Project-Based Learning Proposals',
  'Bonus 5 — Concepts, Questions & Explanations',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex hydrological processes',
  'No more rushed lessons with materials that don\'t work',
  "No more disconnected students who don't see water's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
